import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
// import { actions } from "./store/modules";
import routes from "./plugins/routes";
import "element-theme-default";
import "./assets/main.css";
import { i18n } from "element-react";
import localeTR from "./plugins/i18n/locales/tr";
// import localeEN from "./plugins/i18n/locales/en";
// import { getLocale } from "./helpers";
// import ReactGA from "react-ga";
// import TagManager from 'react-gtm-module'
// import queryString from "query-string";


// const tagManagerArgs = {
//   // gtmId: 'GTM-WW74TWV'
//   gtmId: ''
// }


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isMobile: false,
    };
  }

  componentWillMount() {
    i18n.use(localeTR);
    i18n.use(["tr"]);
    document.addEventListener("resize", this.isMobile);
    

    // let params = queryString.parse(window.location.search);

    // if (params && params.language) {
    //   var currentLanguage = localStorage.getItem("i18nextLng").substr(0, 2);

    //   if (currentLanguage !== params.language) {
    //     this.props.dispatch(actions.auth.changeLanguage());
    //   }
    // }

  }

  componentDidMount() {
    this.isMobile();
    // ReactGA.initialize("UA-55197322-10");
    // ReactGA.initialize("");
    // ReactGA.pageview(window.location.pathname + window.location.search);
    // TagManager.initialize(tagManagerArgs)

  }

  componentWillUnmount() {
    document.removeEventListener("resize", this.isMobile);
  }

  componentWillUpdate() {
    i18n.use(["tr"])
    // i18n.use(getLocale() === "tr-TR" ? localeTR : localeTR);
  }

  isMobile = () => {
    let root = document.getElementById("root");
    this.setState({
      isMobile: root.clientWidth <= 767 ? true : false,
    });
  };

  render() {

    return (
      <div
        style={{ height: "100%" }}
        lang={
          localStorage.getItem("i18nextLng").substr(0, 2)
            ? localStorage.getItem("i18nextLng").substr(0, 2)
            : "tr"
        }
      >
        <BrowserRouter>
          <Switch>
            {routes.map((route, key) => {
              return (
                <Route
                  path={route.path}
                  component={route.component}
                  key={key}
                />
              );
            })}
            <Redirect from="/" to="/auth" />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ ...auth });
export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js